import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { createI18n } from 'vue-i18n'
import { loadFonts } from './plugins/webfontloader'
import './assets/styles/designer.css'

// Import theme CSS
import './assets/styles/theme.css'

// Import your locale files
import en from './locales/en';
import sv from './locales/sv';
import da from './locales/da';
import no from './locales/no';
import fi from './locales/fi';
import de from './locales/de';
import ja from './locales/ja';

loadFonts();

const messages = {
  en,
  sv,
  da,
  no,
  fi, 
  de,
  ja,
}

const username = localStorage.getItem('username') || 'default_user';
const languageKey = `${username}_language`;
const savedLanguage = localStorage.getItem(languageKey) || 'da';

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages,
});

createApp(App)
  .use(i18n)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app');